// Tender Opening list: hero quick filters and the Excel/CSV export. Deadline
// and contract rules are shared with the Plan & Procurement list.

import { formatDateToddmmyyhhmm } from '../../../utils/dateformatter';
import {
  QUICK_FILTERS,
  downloadSheet,
  getContractType,
  getDeadlineInfo,
} from '../../Procurement/utils/procurementList';

// Every tender here is already submitted, so only the deadline insights apply
// (backed by DeadlineStatus on get-all-tender-opening, open tenders only).
export const TENDER_QUICK_FILTERS = QUICK_FILTERS.filter(
  filter => filter.params.DeadlineStatus
);

export const getTenderQuickFilter = key =>
  TENDER_QUICK_FILTERS.find(filter => filter.key === key);

// TenderOpeningStatus 2 = Done; a passed deadline is expected then.
export const isTenderClosed = row => Number(row?.statusCode) === 2;

const stepState = (row, key, isApplicable = true) => {
  if (!isApplicable) return 'N/A';
  return row[key] === true ? 'Done' : 'Open';
};

const toExportRow = row => {
  const deadline = row.proposalSubmissionDeadline;

  return {
    'ID Proc': row.idProc || '',
    Title: row.title || '',
    Product: row.productType?.main || '',
    'Product Type': row.productType?.sub || '',
    'Proc Type': row.procType || '',
    Contract: getContractType(row.contractType)?.label || '',
    'Proposal Deadline': deadline ? formatDateToddmmyyhhmm(deadline) : '',
    'Deadline Status':
      getDeadlineInfo(deadline, isTenderClosed(row))?.label || '',
    Submitted: row.submittedDate || '',
    'Last Update': row.updateDate || '',
    'Request HPS': stepState(row, 'reqHps'),
    'Invite Registered Supplier': stepState(row, 'inviteDmut'),
    'Invite Panitia Tender': row.invitePanitia === true ? 'Sent' : 'Not sent',
    'Request Freight Availability': stepState(
      row,
      'reqFreight',
      Boolean(row.isReqFreightAvailabilityEnable)
    ),
    Status: row.status || '',
  };
};

export const exportTenderOpeningList = (rows, { format, sheetName }) =>
  downloadSheet(rows.map(toExportRow), {
    format,
    prefix: 'TenderOpening',
    sheetName,
  });
